export default __webpack_public_path__ + "static/media/through-the-deep-dark-valley.a3bd17d9.jpg";